var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6088 0.984V3H0.639771V0.984H4.10877L5.13977 0H10.1088L11.1398 0.984H14.6088ZM1.62477 15.984V3.984H13.6248V15.984C13.6248 16.5153 13.4218 16.984 13.0158 17.39C12.6098 17.796 12.1411 17.999 11.6098 17.999H3.64077C3.10944 17.999 2.64077 17.796 2.23477 17.39C1.82877 16.984 1.62577 16.5153 1.62577 15.984H1.62477Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.8a4945c8.svg";
export { ForwardRef as ReactComponent };